import React from 'react'
import TranslationsEditor from './TranslationsEditor.jsx'

export default function BlueprintTranslationsEditor( props ) {
  const { blueprint, ...rest } = props

  return <TranslationsEditor source={blueprint?.data} {...rest} />
}
